import { useTheme } from "next-themes";
import { numberWithCommas, separateNumberParts } from "../utils/numbers";

const FormattedNumber = ({ number }) => {
  const { whole, decimal, hasDecimal } = separateNumberParts(number);
  const { theme } = useTheme();

  return (
    <>
      {numberWithCommas(whole)}
      {hasDecimal ? (
        <>
          {"."}
          <span className='me-1' style={{ fontSize: ".9rem", color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)" }}>
            {decimal}
          </span>
        </>
      ) : (
        <>
          {"."}
          <span className='me-1' style={{ fontSize: ".9rem", color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)" }}>
            {decimal}
          </span>
        </>
      )}
    </>
  );
};

export default FormattedNumber;
